import { useEffect } from 'react';
import { applyThemePhase } from '../utils/themeAccent';

const PHASES = ['green', 'purple'];
const CYCLE_MS = 3000;

const ThemeAccentCycle = () => {
  useEffect(() => {
    let index = 0;

    applyThemePhase(PHASES[index]);

    const intervalId = window.setInterval(() => {
      index = (index + 1) % PHASES.length;
      applyThemePhase(PHASES[index]);
    }, CYCLE_MS);

    return () => window.clearInterval(intervalId);
  }, []);

  return null;
};

export default ThemeAccentCycle;
